/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Addopportunityowner2Inputs */

const en_btn_addopportunityowner2 = /** @type {(inputs: Btn_Addopportunityowner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Opportunity Owner`)
};

/**
* | output |
* | --- |
* | "Edit Opportunity Owner" |
*
* @param {Btn_Addopportunityowner2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_addopportunityowner2 = /** @type {((inputs?: Btn_Addopportunityowner2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Addopportunityowner2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_addopportunityowner2(inputs)
});
export { btn_addopportunityowner2 as "btn_addOpportunityOwner" }